interface CellRenderForMessageProps {
  message: string;
  status: string;
}

const CellRenderForMessage: React.FC<CellRenderForMessageProps> = ({ message, status }) => {
  if (message === null && status === null) {
    return null;
  }

  return <div title={message}>{status}</div>;
};

export default CellRenderForMessage;
